import Caption from 'LuxKit/Typography/Caption'
import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Badge = styled.div`
  display: inline-flex;
  background-color: color-mix(in srgb, ${p => p.theme.palette.neutral.surface.darkBackground} 80%, transparent);
  border-radius: ${p => p.theme.borderRadius.XS};
  padding: ${rem(6)} ${rem(8)};
`

const BadgeText = styled(Caption)`
  color: ${p => p.theme.palette.neutral.surface.darkContrast};
`

function _SponsoredTileBadge({ children }: PropsWithChildren) {
  return <Badge className={_SponsoredTileBadge.name}>
    <BadgeText variant="medium" weight="normal">
      {children}
    </BadgeText>
  </Badge>
}

export default _SponsoredTileBadge
